import { forceCleanCache } from '@/services/utils/websocket';

export const impersonateMember = (payload: { id: string; email: string }) => {
  window.sessionStorage.setItem('impersonation', JSON.stringify(payload));
  forceCleanCache();
  window.location.reload();
};
